import routerOptions0 from "/opt/atlassian/pipelines/agent/build/clients/node_modules/.pnpm/nuxt@4.4.6_@babel+plugin-syntax-jsx@7.29.7_@babel+core@7.29.7__@babel+plugin-syntax-typ_200dbe9c4e635145fe987c6cb6f6705a/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: true,
  strict: false,
  scrollBehaviorType: "auto"
}
export const hashMode = true
export default {
...configRouterOptions,
...routerOptions0,
}